import { Edit, Lock } from '@mui/icons-material';
import { Avatar, Button, Tooltip } from '@mui/material';
import { RawUser } from '@prismamedia/one-user';
import React, { FC, MouseEventHandler, useMemo } from 'react';
import { useStyles } from './styles';

interface LockButtonProps {
  lockedBy?: Partial<Pick<RawUser, 'name' | 'avatarUrl'>> | null;
  disableLockForV0?: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  size?: 'small' | 'medium' | 'large';
}

export const LockButton: FC<LockButtonProps> = ({
  lockedBy,
  className,
  onClick,
  disableLockForV0,
  size = 'medium',
}) => {
  const classes = useStyles();

  const avatarSize = useMemo(() => {
    if (size === 'small') {
      return { width: 24, height: 24 };
    }
    if (size === 'large') {
      return { width: 56, height: 56 };
    }

    return undefined;
  }, [size]);

  return (
    <div className={className}>
      <Tooltip
        title={`${
          disableLockForV0 ? 'En cours de modification' : 'Vérrouillé'
        }${lockedBy ? ` par ${lockedBy.name}` : ''}`}
      >
        <Button
          variant="contained"
          classes={{
            root: classes.lockedButton,
            startIcon: classes.lockedIcon,
          }}
          startIcon={
            disableLockForV0 ? (
              <Edit fontSize={size} />
            ) : (
              <Lock fontSize={size} />
            )
          }
          endIcon={
            <Avatar src={lockedBy?.avatarUrl || undefined} sx={avatarSize} />
          }
          onClick={onClick}
          size={size}
        />
      </Tooltip>
    </div>
  );
};
